import { PageTitle } from "@/components/shared/title/page-title";
import { RootTypeProvider } from "../rootTypes/context/RootTypeContext";
import { UpdateDressCachePage } from "./UpdateDressCachePage";
import { DressCacheProvider } from "./context/DressCacheContext";

const UpdateDressCache = () => {
	return (
		<>
			<PageTitle title="Update Dress Cache" />
			<DressCacheProvider>
				<RootTypeProvider>
					<UpdateDressCachePage />
				</RootTypeProvider>
			</DressCacheProvider>
		</>
	);
};

export default UpdateDressCache;
